import InquiryForm from './inquiry_form'
import requireAuth from '../../require-auth'

export default requireAuth(InquiryForm)



// WEBPACK FOOTER //
// ./src/components/pages/inquiry_form/index.ts